import { PaymentTerm } from '@/@types/payment-term';
import { Table } from '@/components/common';
import { ColumnDefinitionType } from '@/components/common/Table/table.utils';
import { ITablePaginationProps } from '@/components/common/Table/TablePagination';

export interface IPaymentTermsTableProps {
  data: PaymentTerm[];
  columns: ColumnDefinitionType<PaymentTerm>[];
  sort?: 'desc' | 'asc';
  sortBy?: keyof PaymentTerm;
  // eslint-disable-next-line no-unused-vars
  onSort?: (header: string) => void;
  actions: object;
  pagination?: ITablePaginationProps;
}

export function PaymentTermsTable({
  data,
  columns,
  sort,
  sortBy,
  onSort,
  actions,
  pagination,
}: IPaymentTermsTableProps) {
  return (
    <Table
      data={data}
      columns={columns}
      additionalData={actions}
      sort={sort}
      sortBy={sortBy}
      onSort={onSort}
      pagination={pagination}
    />
  );
}
